/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Live_BadgeInputs */

const en_features_live_badge = /** @type {(inputs: Features_Live_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const pl_features_live_badge = /** @type {(inputs: Features_Live_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na żywo`)
};

/**
* | output |
* | --- |
* | "Live" |
*
* @param {Features_Live_BadgeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_live_badge = /** @type {((inputs?: Features_Live_BadgeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Live_BadgeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_live_badge(inputs)
	return en_features_live_badge(inputs)
});